export function getWeekDates(selectedDate: Date): Date[] {
  const date = new Date(selectedDate);

  const dayOfWeek = date.getDay();

  const getDateForOffset = (offset: number): Date => {
    const newDate = new Date(date);

    newDate.setDate(date.getDate() + offset);

    return newDate;
  };

  const weekDates: Date[] = [];

  for (let i = -dayOfWeek; i <= 6 - dayOfWeek; i += 1) {
    weekDates.push(getDateForOffset(i));
  }

  return weekDates;
}
